import momentJalaali from "moment-jalali";
import { Fragment, useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { Printer } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { useHistory, useParams } from "react-router-dom";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { getSMSInvoice } from "../store/api/Invoice";
import { useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import BihamtaTable from "../../Components/BihamtaTable";

const SMSInvoice = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { invoiceNumber, durationID, mobile, serverUrl } = useParams();
    const [invoice, setInvoice] = useState({
        CustomerCat: 0,
        IsFormal: false,
        PaymentMethod: 0,
        Discount: 0,
        TaxFee: 0,
        InvoiceTotalPrice: 0,
        InvoicePureTotalPrice: 0,
        FreightCharge: 0,
        ContactDate: momentJalaali().local("en").format("YYYY-MM-DD")
    });
    const isFormal = invoice.IsFormal;
    const invoiceID = invoice.InvoiceID;
    function printInvoice(e) {
        const reportName = (isFormal ? "Formal" : "") + "SaleInvoice";
        history.push({
            pathname: `/PrintViewer/${reportName}/${e.ctrlKey}`,
            state: {
                dataUrl: `api/InvoiceAPI/GetSMSInvoice?invoiceNumber=${invoiceNumber}&durationID=${durationID}&mobile=${mobile}`,
                serverUrl: serverUrl.replace(":::", "://")+"/",
                method: "get"
            }
        });
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "مشخصات کالا", colName: "ProductName+ProductModel", showInMobile: true, colType: "string" },
        { colTitle: "سریال کالا", colName: "ProductSerial", showInMobile: true },
        { colTitle: "تعداد", colName: "ProductCount", showInMobile: false },
        { colTitle: "قیمت واحد", colName: "UnitPrice", showInMobile: false, colType: "currency" },
        { colTitle: "درصد تخفیف", colName: "DiscountPercent", showInMobile: false },
        { colTitle: "تخفیف", colName: "DiscountPercent", showInMobile: false, colType: "currency" },
        { colTitle: "درصد مالیات", colName: "TaxPercent", showInMobile: false },
        { colTitle: "ارزش افزوده", colName: "Tax", showInMobile: false, colType: "currency" },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", showInMobile: false, colType: "currency" },
    ]
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-فروش و انبار";
        if (Number(invoiceNumber) > 0) {
            const onGetInvoice = (data) => {
                if (data.Error) {
                    setErrorDialog(dispatch, data.Error, "دریافت اطلاعات فاکتور");
                }
                else {
                    if (data !== "PENDING") {
                        data.InvoiceTotalPrice = data.InvoiceDetailList.map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                        if (isFormal === "true") {
                            data.InvoicePureTotalPrice = data.InvoiceDetailList.map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0);
                        }
                        else {
                            data.InvoicePureTotalPrice = data.InvoiceTotalPrice - data.Discount + data.FreightCharge + data.TaxFee;
                        }
                        if (data.InvoiceTotalPrice - data.Discount > 0) {
                            data.TaxPercent = Number(parseFloat(data.TaxFee / (data.InvoiceTotalPrice - (data.Discount ?? 0)) * 100).toFixed(2));
                        }
                        if (data.InvoiceTotalPrice > 0) {
                            data.DiscountPercent = Number(parseFloat(data.Discount / data.InvoiceTotalPrice * 100).toFixed(2));
                        }
                    }
                    setInvoice(data);
                }
            }
            getSMSInvoice(invoiceNumber, durationID, mobile, serverUrl.replace(":::", "://"), onGetInvoice);
        }
    }, []);
    return (
        <div className="container-fluid mt-0">
            <Card >
                <Card.Header className="headerStyle"><FontAwesomeIcon icon={faFileInvoice} size="lg" /> {"فاکتور فروش" + (isFormal === "true" ? " رسمی" : "")}</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }} >
                    {invoice === "PENDING" &&
                        <div style={{ textAlign: "center" }}>
                            <Loader type="BallTriangle" color="#bb1370" width="30" height="30" />
                        </div>
                    }
                    {invoice && invoice !== "PENDING" &&
                        <Fragment>
                            <div className="row" style={{ border: "1px solid gray", borderRadius: "3px", padding: "0px 8px 15px 8px", margin: "0" }}>
                                <div className="col-md-4 form-group" style={{ marginLeft: "auto" }}>
                                    <div className="row">
                                        <label>طرف حساب</label>
                                        <div className="col-md-7">
                                            <input type="text" className="form-control" readOnly value={invoice.CustomerName ?? ""}></input>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-2 form-group">
                                    <label>تاریخ فاکتور</label>
                                    <DatePicker popperPlacement="top-start" isGregorian={false} timePicker={false} className="form-control"
                                        value={momentJalaali(invoice.ContactDate.substring(0, 10))} readOnly />
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>شماره سیستمی فاکتور</label>
                                    <input type="text" className="form-control" value={invoice.InvoiceNumber ?? ""} readOnly />
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>شماره دستی فاکتور</label>
                                    <input type="text" className="form-control" value={invoice.ManualInvoiceNumber ?? ""} readOnly />
                                </div>
                            </div>

                            <BihamtaTable columns={tableColes} dataList={{ Data: invoice.InvoiceDetailList }} />
                            <div className="row" style={{ border: "1px solid gray", borderRadius: "3px", margin: 0, paddingBottom: "12px" }}>
                                <div className={"form-group col-md-2"} style={{ marginLeft: "auto" }}>
                                    <div>
                                        <label>فروشنده </label>
                                        <input type="text" className="form-control" value={invoice.StaffName} readOnly />
                                    </div>
                                    <table className="flexTable mt-2" style={{ fontSize: "12px", fontWeight: "normal" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ fontWeight: "normal", textAlign: "right" }}>نحوه تسویه فاکتور</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "100%" }}>
                                                    <select className="form-control" style={{ height: "36.8px" }}
                                                        value={invoice.PaymentMethod} readOnly >
                                                        <option value={0} style={{ width: "100%", display: "block" }}> تسویه نشده</option>
                                                        <option value={1} style={{ width: "100%", display: "block" }}>نقد</option>
                                                        <option value={2} style={{ width: "100%", display: "block" }}>چک و نقد</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="form-group col-md-4">
                                    <table style={{ fontSize: "12px", float: "left" }}>
                                        <tbody>
                                            <tr >
                                                <td>جمع کل: </td>
                                                <td><input className="form-control tableRowInput" readOnly style={{ marginTop: 0 }} value={invoice.InvoiceTotalPrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} /></td>
                                            </tr>
                                            <tr>
                                                <td>تخفیف: </td>
                                                <td>
                                                    <input type="text" className="tableRowInput" style={{ marginTop: 0 }} value={invoice.Discount ?? 0} readOnly />
                                                </td>
                                                {isFormal !== "true" &&
                                                    <Fragment>
                                                        <td>
                                                            <input type="number" className=" form-control tableRowInput" style={{ width: "72px", marginTop: 0 }} min={0} max={100} value={invoice.DiscountPercent ?? 0}
                                                                readOnly />
                                                        </td>
                                                        <td style={{ fontSize: "13px", fontWeight: "bold" }}>%</td>
                                                    </Fragment>
                                                }
                                            </tr>
                                            <tr>
                                                <td>ارزش افزوده: </td>
                                                <td><input type="text" className="tableRowInput" style={{ marginTop: 0 }} value={invoice.TaxFee.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) ?? 0} readOnly /></td>
                                                {isFormal !== "true" &&
                                                    <Fragment>
                                                        <td>
                                                            <input type="number" className=" form-control tableRowInput" style={{ width: "72px", marginTop: 0 }} min={0} max={100} value={invoice.TaxPercent ?? 0}
                                                                readOnly />
                                                        </td>
                                                        <td style={{ fontSize: "13px", fontWeight: "bold" }}>%</td>
                                                    </Fragment>
                                                }
                                            </tr>
                                            <tr>
                                                <td>سایر هزینه ها: </td>
                                                <td><input type="text" className="tableRowInput" style={{ marginTop: 0 }} value={invoice.FreightCharge.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) ?? 0} readOnly /></td>
                                            </tr>
                                            <tr>
                                                <td>قابل پرداخت: </td>
                                                <td><input className="tableRowInput form-control" style={{ marginTop: 0 }} readOnly value={invoice.InvoicePureTotalPrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) ?? 0} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row mt-1" style={{ border: "1px solid gray", borderRadius: "3px", margin: 0, paddingBottom: "12px" }}>
                                <div className="col-md-5 form-group">
                                    <label>توضیحات</label>
                                    <textarea className="form-control" rows={2} readOnly value={invoice.Description ?? ""} />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-5" style={{ marginLeft: "auto" }}>
                                    {Number(invoiceID) > 0 && <Button variant="secondary" className="group-Btn-large" onClick={printInvoice}><Printer size={18} />&nbsp;چاپ فاکتور</Button>}
                                </div>
                            </div>
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div >
    )
}
export default SMSInvoice;